import { TimeFilterInterval } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import { createReducer } from '@mews/framework';
import { SET_FILTERS } from '../actionTypes';

const initialState = {
    filters: {
        startUtc: null,
        endUtc: null,
    },
};

const sidebarReducer = createReducer(initialState, {
    [SET_FILTERS]: (state: ApplicationState, filters: TimeFilterInterval) => ({
        ...state,
        filters,
    }),
});

export default sidebarReducer;
